import React from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

function NewDepositCashAccount(props) {
  const { deposit, setDeposit, isDisabled } = props;
  const {originAccounts} = props;

  return (
    <CardContainer icon={null}>
      <GridContainer>
        <GridItem xs={4}>
          <Autocomplete
            disabled={isDisabled}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Cuenta origen" />}
            options={originAccounts}
            getOptionLabel={(option) => {
              if (option === null) return '';
              return `${option.AcctCode} - S/${parseFloat(option.CurrTotal).toFixed(2)} - ${
                option.AcctName
              }`;
            }}
            value={originAccounts.find((account) => account.AcctCode === deposit.AllocAcct) || null}
            onChange={(e, item) => {
              if (item === null) {
                setDeposit((deposit) => ({ ...deposit, AllocAcct: undefined }));
                return;
              }
              setDeposit((deposit) => ({ ...deposit, AllocAcct: item.AcctCode }));
            }}
          />
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default NewDepositCashAccount;
